function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Upload ");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.74
}, React.createElement("g", {
  id: "upload",
  fill: "#000000"
}, React.createElement("g", {
  id: "upload-(1)"
}, React.createElement("path", {
  d: "M15.0593079,7.86537572 C14.8125419,7.86537572 14.6151291,8.08677969 14.6151291,8.36353464 L14.6151291,12.8949357 C14.6151291,14.1274178 13.720191,15.1274257 12.6245498,15.1274257 L2.87893696,15.1274257 C1.78000559,15.1274257 0.88835769,14.1237277 0.88835769,12.8949357 L0.88835769,8.28973332 C0.88835769,8.01297836 0.69094487,7.7915744 0.444178845,7.7915744 C0.19741282,7.7915744 0,8.01297836 0,8.28973332 L0,12.8949357 C0,14.6772376 1.29305397,16.1237435 2.87893696,16.1237435 L12.6245498,16.1237435 C14.213723,16.1237435 15.5034868,14.6735475 15.5034868,12.8949357 L15.5034868,8.36353464 C15.5034868,8.09046975 15.306074,7.86537572 15.0593079,7.86537572 Z",
  id: "Path",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M5.24131037,4.02770706 L7.30756455,1.7103456 L7.30756455,11.8174364 C7.30756455,12.0941914 7.50497737,12.3155953 7.7517434,12.3155953 C7.99850942,12.3155953 8.19592224,12.0941914 8.19592224,11.8174364 L8.19592224,1.7103456 L10.2621764,4.02770706 C10.347722,4.12364878 10.4628795,4.1753097 10.5747467,4.1753097 C10.6899042,4.1753097 10.8017715,4.12733884 10.887317,4.02770706 C11.0616983,3.83213356 11.0616983,3.51847795 10.887317,3.32290445 L8.0643137,0.156827806 C7.98205835,0.0645761554 7.86690088,0.00922516505 7.7517434,0.00922516505 C7.6332957,0.00922516505 7.52142844,0.0608860893 7.4391731,0.156827806 L4.61616977,3.32290445 C4.44178845,3.51847795 4.44178845,3.83213356 4.61616977,4.02770706 C4.78726088,4.2195905 5.07021926,4.2195905 5.24131037,4.02770706 Z",
  id: "Path",
  fillRule: "nonzero"
}))));

var SvgUploadTable = function SvgUploadTable(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUploadTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-table.31be2f48.svg";
export { ForwardRef as ReactComponent };